import React from 'react'
import { isNullOrEmpty } from './index'
import ErrorText from '../components/typography/ErrorText'
import {
  AppIcon,
  VideoIcon,
  AudioIcon,
  ImageIcon,
  DocumentIcon,
  PresentationIcon,
  SimulationIcon,
  WebIcon
} from '../components/quest/activity/resources/_Styled'

export function isResourceComplete(resource) {
  let incomplete = false
  if (
    isNullOrEmpty(resource.name) ||
    (!resource.url && !resource.file_name && !resource.file)
  ) {
    incomplete = true
  }

  if (
    resource.file_name &&
    resource.file_name.length > 0 &&
    !resource.license_citation &&
    !resource.license_id
  ) {
    incomplete = true
  }

  return !incomplete
}

export function mapResources(resources) {
  return resources.map(r => ({
    ...r,
    isResourceIncomplete: !isResourceComplete(r)
  }))
}

export const ResourceIncomplete = () => (
  <ErrorText style={{ marginTop: '10px' }}>
    {'\u25CB \xa0Resource Incomplete'}
  </ErrorText>
)

export const isYoutubeLink = (link, type) =>
  type === 'video' &&
  Boolean(link) &&
  link.length > 0 &&
  (link.includes('.youtube.') || link.includes('youtu.be'))

export const convertMinutesAndSecondsToSeconds = (minutes, seconds) =>
  (parseInt(minutes) || 0) * 60 + (parseInt(seconds) || 0)

export const validateSecondsInput = e => {
  if (e.target.value.length > e.target.max.length) {
    // If the value has more digits than the max, only use the first two digits
    e.target.value = e.target.value.slice(0, 2)
  } else if (parseInt(e.target.value) > parseInt(e.target.max)) {
    // if the value is greater than the max, only use the first digit ie prevent more digits
    e.target.value = e.target.value.slice(0, 1)
  }
}

export const preventUnwantedNumberKeys = e => {
  // prevent alpha/non-numeric keys
  if (
    !parseInt(e.key) &&
    // allow 0, but don't allow ")"
    (e.keyCode !== 48 || e.key === ')') &&
    // allow backspace
    e.keyCode !== 8 &&
    // allow tab
    e.keyCode !== 9 &&
    // allow arrow left
    e.keyCode !== 37 &&
    // allow arrow right
    e.keyCode !== 39 &&
    // allow 0 on numpad
    e.keyCode !== 96
  ) {
    e.preventDefault()
  }
}

export const getYoutubeTimeValueForEndpoint = (minutes, seconds, url, type) => {
  if (
    isYoutubeLink(url, type) &&
    !(isNullOrEmpty(minutes) && isNullOrEmpty(seconds))
  ) {
    return convertMinutesAndSecondsToSeconds(minutes, seconds)
  }
  return null
}

export const getViewResourceIcon = type => {
  let retVal = null
  switch (type) {
    case 'web': {
      retVal = <WebIcon />
      break
    }
    case 'video': {
      retVal = <VideoIcon />
      break
    }
    case 'audio': {
      retVal = <AudioIcon />
      break
    }
    case 'image': {
      retVal = <ImageIcon />
      break
    }
    case 'game_app': {
      retVal = <AppIcon />
      break
    }
    case 'document': {
      retVal = <DocumentIcon />
      break
    }
    case 'presentation': {
      retVal = <PresentationIcon />
      break
    }
    case 'simulation': {
      retVal = <SimulationIcon />
    }
  }
  return retVal
}

export const resourceHasQMSpecificInfo = resource =>
  Boolean(
    resource.start_time ||
      resource.end_time ||
      resource.copyright_holder ||
      (resource.file_name && resource.license_citation) ||
      (resource.content_warnings &&
        Object.keys(resource.content_warnings).length > 0)
  )



// WEBPACK FOOTER //
// ./src/utils/resources.js